import { useState } from "react"

import { DnoCommissioningResponses } from "../../../../../constants/enums"
import { parseErrorAsObj } from "../../../../../errors/errorProcessors"
import { IAppError } from "../../../../../errors/errorTypes"
import { snackbar } from "../../../../../utils/general/generalUtils"
import { postClientProtected } from "../../../clients/clients"
import { DNO_COMMISSIONING_RESPONSE } from "../../../urls/hybrid"

interface IDnoCommissioningResponseHook {
    isSending: boolean
    error: IAppError | undefined
    postCommissioningResponse: (
        onSuccess: () => void,
        applicationId: string,
        action: DnoCommissioningResponses,
        comment: string,
        exportMpan?: string
    ) => Promise<void>
}

const useDnoCommissioningResponse = (): IDnoCommissioningResponseHook => {
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const postCommissioningResponse = async (
        onSuccess: () => void,
        applicationId: string,
        action: DnoCommissioningResponses,
        comment: string,
        exportMpan?: string
    ): Promise<void> => {
        try {
            setIsSending(true)
            const postBody = exportMpan
                ? {
                      applicationId,
                      action,
                      comment,
                      exportMpan,
                  }
                : {
                      applicationId,
                      action,
                      comment,
                  }
            await postClientProtected(DNO_COMMISSIONING_RESPONSE, postBody)
            snackbar("Commissioning response submitted successfully", "success")
            onSuccess()
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
        } finally {
            setIsSending(false)
        }
    }

    return {
        isSending,
        error,
        postCommissioningResponse,
    }
}

export default useDnoCommissioningResponse
